<div class="w-full">
  <div>
    <p-listbox
      [options]="cities()"
      [(ngModel)]="selectedCityId"
      optionLabel="displayName"
      optionValue="cityId"
      [filter]="true"
      [style]="{ width: '15rem' }"
      (onChange)="onCityChange()"
      (onFilter)="onCityFilter($event)"
    />
    <div class="mt-4 flex gap-4">
      <div class="flex-1">
        <label for="cityInput" class="block mb-1">Город</label>
        <input
          pInputText
          id="cityInput"
          [value]="selectedCity()?.cityName || ''"
          class="w-full"
          readonly
        />
      </div>
      <div class="flex-1">
        <label for="regionInput" class="block mb-1">Регион</label>
        <input
          pInputText
          id="regionInput"
          [value]="selectedCity()?.regionName || ''"
          class="w-full"
          readonly
        />
      </div>
      <div class="flex-1">
        <label for="countryInput" class="block mb-1">Страна</label>
        <input
          pInputText
          id="countryInput"
          [value]="selectedCity()?.countryName || ''"
          class="w-full"
          readonly
        />
      </div>
    </div>
    <div style="display: flex; justify-content: flex-end; gap: 1rem; width: 100%; margin-top: 1.5rem;">
      <p-button
        label="Отмена"
        styleClass="p-button-secondary"
        (onClick)="onCancel()"
        [style]="{ minWidth: '120px' }"
      ></p-button>
      <p-button
        label="Сохранение"
        styleClass="p-button-primary"
        (onClick)="onSave()"
        [disabled]="!selectedCity()"
        [style]="{ minWidth: '120px' }"
      ></p-button>
    </div>
  </div>
</div>
